class GridColumnsImage extends HTMLElement {
  constructor() {
    super();
    this.flickity = null;
    this.isInitialized = false;
    this.resizeTimeout = null;
    this.isMobile = window.innerWidth < 750;
  }

  connectedCallback() {
    this.init();
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  disconnectedCallback() {
    this.destroy();
    window.removeEventListener('resize', this.handleResize.bind(this));
  }

  init() {
    if (this.isInitialized) return;

    this.waitForFlickity().then(() => {
      this.setupSlider();
      this.isInitialized = true;
    });
  }

  async waitForFlickity() {
    if (window.Flickity) return;

    return new Promise((resolve) => {
      const checkFlickity = () => {
        if (window.Flickity) {
          resolve();
        } else {
          setTimeout(checkFlickity, 100);
        }
      };
      checkFlickity();
    });
  }

  setupSlider() {
    const slider = this.querySelector('[data-flickity-mobile]');
    if (!slider) return;

    if (this.isMobile && !this.flickity) {
      this.initFlickity(slider);
    } else if (!this.isMobile && this.flickity) {
      this.destroyFlickity();
    }
  }

  initFlickity(slider) {
    const options = this.getFlickityOptions();

    try {
      this.flickity = new Flickity(slider, options);
      this.classList.add('flickity-enabled');
    } catch (error) {
      console.error("Erreur lors de l'initialisation de Flickity:", error);
    }
  }

  getFlickityOptions() {
    return {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      groupCells: false,
      draggable: true,
      wrapAround: false,
      adaptiveHeight: true,
      accessibility: true,
      resize: true,
    };
  }

  destroyFlickity() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
      this.classList.remove('flickity-enabled');
    }
  }

  handleResize() {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }

    this.resizeTimeout = setTimeout(() => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 750;

      if (wasMobile !== this.isMobile) {
        this.setupSlider();
      } else if (this.flickity) {
        this.flickity.resize();
      }
    }, 250);
  }

  destroy() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
    }
    this.isInitialized = false;

    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
  }

  refresh() {
    this.destroy();
    setTimeout(() => {
      this.init();
    }, 100);
  }
}

if (!customElements.get('grid-columns-image')) {
  customElements.define('grid-columns-image', GridColumnsImage);
}

document.addEventListener('DOMContentLoaded', () => {
  const grids = document.querySelectorAll('grid-columns-image');
  grids.forEach((grid) => {
    if (!grid.isInitialized) {
      grid.init();
    }
  });
});

document.addEventListener('shopify:section:load', (event) => {
  const grid = event.target.querySelector('grid-columns-image');
  if (grid) {
    grid.refresh();
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  const grid = event.target.querySelector('grid-columns-image');
  if (grid) {
    grid.destroy();
  }
});
